import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { partnerDataStoreService } from 'legacy/lut/classes/services/PartnerDataStoreService'

import { IForm } from 'core-components/classes/models/IForm'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { siteBuilderGetState } from 'core/sitebuilder/store'
import { CrudStore } from 'core/types/crudStore'

import { IAbilityValues } from '../contactEditDialog/models'

import { IPartnerFlags } from './models'

const savePartnerFlagsRequests = async (
  newPartnerFlagsRequests: IPartnerFlags[],
  type: string,
  partnerId: string,
  Market: string,
  Country: string
) => {
  const crud = CrudStore.get(CrudStoreItem.PartnerFlagsRequests)

  let Source = ''
  const page = siteBuilderGetState().routeParams.page
  if (page === 'newpartners' || page === 'partner-dashboard' || page.includes('hpscoutso')) {
    Source = 'Click&Go'
  } else if (page.includes('request')) {
    Source = 'Onboarding'
  }

  const oldData = await getPartnerFlagsRequests(partnerId, type)
  const newData = newPartnerFlagsRequests
    .filter((item) => item.Status === 'New')
    .map((item) => ({
      ...item,
      PartnerId: partnerId,
      Type: type,
    }))

  const itemsUpdate: any[] = []
  const itemsCreate: any[] = []
  newData.map(async (item) => {
    const temp = oldData.find(
      (v) => v.Code === item.Code && v.Status !== 'Done' && v.Status !== 'Rejected'
    )
    if (temp) {
      if (
        temp.EndDate !== item.EndDate ||
        temp.Action !== item.Action ||
        temp.Status !== item.Status ||
        temp.StartDate !== item.StartDate
      ) {
        itemsUpdate.push({
          ...item,
          Market: Market || temp.Market,
          Country: Country || temp.Country,
          Source: item.Source || Source,
        })
      }
    } else {
      itemsCreate.push({
        ...item,
        Market,
        Country,
        Source: item.Source || Source,
      })
    }
  })

  if (itemsCreate.length) {
    await crud.create('519', itemsCreate)
  }
  if (itemsUpdate.length) {
    await crud.update('519', itemsUpdate)
  }
  for (const item of newData) {
    const oldItem = oldData.find(
      (oldItem) => item.EntryId === oldItem.EntryId && oldItem.Status === 'Rejected'
    )
    if (oldItem) {
      await crud.delete('519', oldItem)
    }
  }

  for (const oldItem of oldData) {
    const temp = newData.find((v) => v.Code === oldItem.Code)
    if (!temp) {
      crud.delete('519', oldItem)
    }
  }
}

const getPartnerFlags = async (partnerId: string, type: string) => {
  const result = await partnerDataStoreService.getCodes([partnerId], 1000)

  let data: IPartnerFlags[] = []
  if (result) {
    const items: any[] = result[type === 'Program' ? 'ProgramCodes' : 'AccreditationCodes'].items
    data = items.map((item: any) => {
      return {
        EntryId: item.EntryID,
        Type: item.CodeType,
        Status: '',
        Code: item.Code,
        CodeName: item.CodeName,
        Caption: item.CodeName,
        StartDate: item.START_DATE,
        EndDate: item.END_DATE,
        PartnerId: item.PARTNER_ID,
        Action: '',
        LastActionDate: '',
        Comment: '',
      }
    })
  }
  return data
}

const getPartnerFlagsRequests = async (partnerId: string, type: string) => {
  const crud = CrudStore.get(CrudStoreItem.PartnerFlagsRequests, 'partnerFlags')
  crud.removeQueries(true)
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'Type',
        operator: Operator.EQUAL,
        value: type,
      },
      {
        field: 'Status',
        operator: Operator.NOTEQUAL,
        value: 'Done',
      },
    ],
  })
  crud.setPaging({
    page: 0,
    pageSize: 100,
  })
  const result = (await crud.fetch()).items

  const data: IPartnerFlags[] = []
  if (result.length) {
    result.forEach((item) => {
      data.push({
        ...item,
        LastActionDate: item.Modified,
      })
    })
  }
  return data
}

const getCodesDictionary = async (type: string) => {
  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        operator: Operator.EQUAL,
        field: 'Type',
        value: type,
      },
    ],
  }

  const crud = CrudStore.get(CrudStoreItem.CodesDictionary, 'getCodesDictionary')
  crud.removeQueries(true)
  crud.setPaging({
    page: 0,
    pageSize: 1500,
  })
  crud.setFilter(filter)
  const result = await crud.fetch()

  const data: { [v: string]: IAbilityValues[] } = {}
  if (result.items.length) {
    result.items.forEach((el: IForm) => {
      if (el.Code) {
        const newValue: IAbilityValues = {
          id: el.Code,
          caption: el.Code,
          roles: el.Roles ? el.Roles.split(';') : [],
          CodeName: el.CodeName || '',
          GeoMarket: el.GeoMarket ? el.GeoMarket.split(';') : [],
          Users: el.Users ? el.Users.split(';') : [],
        }
        if (data[el.Code]) {
          data[el.Code].push(newValue)
        } else {
          data[el.Code] = [newValue]
        }
      }
    })
  }

  return data
}

export { getPartnerFlags, getPartnerFlagsRequests, savePartnerFlagsRequests, getCodesDictionary }
